import {ChangeDetectionStrategy, Component} from '@angular/core';
import { ToolbarItemAbstract } from '../toolbar-item-abstract.component';
import { MessageGrowlService } from '../../../../../../../core/message/message-growl.service';
import { MessageService } from '../../../../../../../core/message/message.service';
import { GenericCrudService } from '../../../../../../services/generic-crud.service';
import { ComponentService } from '../../../../../services/component-highlight-stack.service';
import {EntityDataStoreService} from '../../../../../services/entity-data-store.service';
import {TranslateService} from '@ngx-translate/core';
import {FormViewerComponent} from '../../../../../../form-viewer/form-viewer.component';
import {EntityStatus} from '../../../../../../services/entity/entity-status';
import {TOAST_LIFE_INFINITE, ToastComponentsRegistry, ToastService} from '../../../../../../../core/service/toast.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-toolbar-item-set-order-offer-confirmed-state',
  templateUrl: './toolbar-item-set-order-offer-confirmed-state.component.html'
})
export class ToolbarItemSetOrderOfferConfirmedStateComponent extends ToolbarItemAbstract {

  constructor(
    protected messageGrowlService: MessageGrowlService,
    protected messageService: MessageService,
    protected genericCrudService: GenericCrudService,
    private entityDataStore: EntityDataStoreService,
    protected componentService: ComponentService,
    protected translateService: TranslateService,
    protected toastService: ToastService
  ) {
    super();
  }

  public click() {
    const component = this.getComponent();

    if (component instanceof FormViewerComponent) {
      const entity = component.entity;
      const customEntity = {
        'fqn': entity.fqn,
        'uniqueId': entity.uniqueId,
        'isChanged': true,
        '_embedded': {},
        'cssColor': 'green'
      };

      this.toastService.custom(ToastComponentsRegistry.PROGRESS_BAR, {
        severity: 'info',
        life: TOAST_LIFE_INFINITE,
        closable: false,
        summary: this.translateService.instant('COMMON.SAVING_PLEASE_WAIT')
      });
      this.genericCrudService.editEntity('phoenix/orders/' + entity.id, customEntity).subscribe((order) => {
        this.toastService.clear(ToastComponentsRegistry.PROGRESS_BAR, 300);
        this.messageGrowlService.success('Done.');
      });
    }
  }
}
